// extracted by mini-css-extract-plugin
export var addButton = "_du-4";
export var contentBlockImage = "_du-i";
export var contentBlockWidgetPreview = "_du-g";
export var fulfillmentCutoffWidgetPreview = "_du-9";
export var imageBackdrop = "_du-6";
export var imageIcon = "_du-8";
export var lowProfileImageContainer = "_du-b";
export var lowProfileImageIcon = "_du-f";
export var lowProfileImageIconContainer = "_du-e";
export var lowProfileImagePlaceholder = "_du-d";
export var lowProfileProductImage = "_du-c";
export var lowProfileProductUpsellWidgetPreview = "_du-a";
export var productCard = "_du-5";
export var productImage = "_du-7";
export var productReviewsWidgetPreview = "_du-h";
export var progressBar = "_du-1";
export var progressBarFill = "_du-2";
export var progressBarTrack = "_du-3";
export var shippingOptionWidgetPreview = "_du-j";
export var shippingUpsellProgressBar = "_du-k";
export var thresholdUpsellWidgetPreview = "_du-0";